// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.trustmanagement

import org.multipaz.cbor.DataItem
import org.multipaz.trustmanagement.TrustEntry
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.trustmanagement.TrustEntryRical
import org.multipaz.trustmanagement.TrustEntryVical
import org.multipaz.trustmanagement.TrustEntryX509Cert

fun TrustEntry.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "f5kC4KTaSMQE4rsrDKlucD1ZFYqPFSspXLHHb2ht-6s")
val TrustEntry_cborSchemaId = ByteString(127, -103, 2, -32, -92, -38, 72, -60, 4, -30, -69, 43, 12, -87, 110, 112, 61, 89, 21, -118, -113, 21, 43, 41, 92, -79, -57, 111, 104, 109, -5, -85)

fun TrustEntry.Companion.fromCbor(data: ByteArray): TrustEntry {
    return TrustEntry.fromDataItem(Cbor.decode(data))
}

val TrustEntry.Companion.cborSchemaId: ByteString
    get() = TrustEntry_cborSchemaId

fun TrustEntry.toDataItem(): DataItem {
    return when (this) {
        is TrustEntryRical -> (this as TrustEntryRical).toDataItem()
        is TrustEntryVical -> (this as TrustEntryVical).toDataItem()
        is TrustEntryX509Cert -> (this as TrustEntryX509Cert).toDataItem()
    }
}

fun TrustEntry.Companion.fromDataItem(dataItem: DataItem): TrustEntry {
    val type = dataItem["type"].asTstr
    return when (type) {
        "Rical" -> TrustEntryRical_fromDataItem(dataItem)
        "Vical" -> TrustEntryVical_fromDataItem(dataItem)
        "X509Cert" -> TrustEntryX509Cert_fromDataItem(dataItem)
        else -> throw IllegalArgumentException("wrong type: $type")
    }
}
